module.exports = __webpack_public_path__ + "static/buzzfeed@2x-c58486752fc496ffd8cfd27ac3e94c6d.png";


//////////////////
// WEBPACK FOOTER
// ./src/media/images/pages/resources/buzzfeed@2x.png
// module id = 2677
// module chunks = 157636680307020